"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _functional_utility = require("../../../../packages/common-utilities/src/functional_utility");

var _functional_utility2 = _interopRequireDefault(_functional_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Truncate = function (_Component) {
  _inherits(Truncate, _Component);

  function Truncate() {
    var _ref;

    _classCallCheck(this, Truncate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = Truncate.__proto__ || Object.getPrototypeOf(Truncate)).call.apply(_ref, [this].concat(args)));

    _this.getTextWidth = _this.getTextWidth.bind(_this);
    _this.showEllipsis = _this.showEllipsis.bind(_this);
    _this.state = {
      ellipsisStyle: {}
    };
    return _this;
  }

  _createClass(Truncate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.ellipsisElWidth = this.ellipsisEl && this.ellipsisEl.offsetWidth > 0 ? this.ellipsisEl.offsetWidth : 64;
      var ellipsisStyle = this.showEllipsis() ? { float: "left" } : { display: "none" };
      this.setState({
        ellipsisStyle: ellipsisStyle
      }, function () {
        return _functional_utility2.default.setAriaAttrsWithTruncatedText(_this2.textEl, _this2.ariaText, function () {
          return (0, _functional_utility.pathOrNull)(['ellipsisStyle', 'display'], _this2.state) === "none";
        });
      });
    }
  }, {
    key: "showEllipsis",
    value: function showEllipsis() {
      var textWidth = this.getTextWidth();
      return this.props.showMore && (this.props.lines > 1 || this.props.containerWidth > 0 && textWidth >= this.props.containerWidth);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;

      var predicate = function predicate() {
        return (0, _functional_utility.pathOrNull)(['ellipsisStyle', 'display'], _this3.state) === "none";
      };
      if (!this.props.showMore && this.state.ellipsisStyle && this.state.ellipsisStyle.display !== "none") {
        this.setState({
          ellipsisStyle: { display: "none" }
        }, function () {
          return _functional_utility2.default.setAriaAttrsWithTruncatedText(_this3.textEl, _this3.ariaText, predicate);
        });
      }

      if (this.showEllipsis() && this.state.ellipsisStyle && this.state.ellipsisStyle.display === "none") {
        this.setState({
          ellipsisStyle: { float: "left" }
        }, function () {
          return _functional_utility2.default.setAriaAttrsWithTruncatedText(_this3.textEl, _this3.ariaText, predicate);
        });
      }
    }
  }, {
    key: "getTextWidth",
    value: function getTextWidth() {
      return this.referenceEl ? this.referenceEl.getBoundingClientRect().width : 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          lines = _props.lines,
          children = _props.children,
          ellipsis = _props.ellipsis,
          id = _props.id;
      var ellipsisStyle = this.state.ellipsisStyle;


      var textStyle = lines > 0 && ellipsisStyle && ellipsisStyle.display !== "none" ? {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        height: "19px",
        float: "left",
        maxWidth: "calc(100% - " + (this.ellipsisElWidth + 2) + "px)"
      } : {};

      var ariaTextId = "aria-r-id-" + this.props.placementId;
      return _react2.default.createElement(
        "div",
        { ref: function ref(el) {
            return _this4.truncateContainer = el;
          } },
        _react2.default.createElement(
          "div",
          {
            ref: function ref(textEl) {
              return _this4.referenceEl = textEl;
            },
            style: { position: "absolute", visibility: "hidden", width: "%200", top: "-1000px" } },
          children
        ),
        this.state.ellipsisStyle.display !== "none" ? _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            "div",
            { ref: function ref(textEl) {
                return _this4.textEl = textEl;
              }, "aria-hidden": "false", "aria-labelledby": ariaTextId, "aria-describedby": ariaTextId, role: "region", style: textStyle },
            _react2.default.createElement(
              "span",
              { "aria-hidden": "true" },
              children
            )
          ),
          _react2.default.createElement("span", { id: ariaTextId, ref: function ref(ariaText) {
              return _this4.ariaText = ariaText;
            }, style: { position: 'absolute', left: '-1000vw', height: 0 } }),
          _react2.default.createElement(
            "span",
            { ref: function ref(ellipsisEl) {
                return _this4.ellipsisEl = ellipsisEl;
              }, style: this.state.ellipsisStyle, id: id },
            ellipsis
          )
        ) : _react2.default.createElement(
          "div",
          { ref: function ref(textEl) {
              return _this4.textEl = textEl;
            }, style: textStyle },
          children
        )
      );
    }
  }]);

  return Truncate;
}(_react.Component);

exports.default = Truncate;